import { createFetch } from '@vueuse/core'
import { destr } from 'destr'
import { useAppStore } from '@/stores/appStore'
import { useAuthStore } from '@/stores/authStore'
import { gettext } from '@/plugins/gettext'


export const useApi = createFetch({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  fetchOptions: {
    headers: {
      Accept: 'application/json',
    },
  },
  options: {
    refetch: true,
    async beforeFetch({ options }) {
      let uuid = false
      if (options.loading) {
        const store = useAppStore()
        uuid = await store.startLoading()
        options.onResponse = ({ response }) => {
          store.endLoading(uuid)
          if (response.status !== 200 && response.status !== 201) return

          if (options.method === 'POST') {
            if (!options.hasOwnProperty('noPushMessage')) {
              store.pushErrorMessage({ success: true })
            }
          }

          if (options.method === 'DELETE') {
            const { $gettext } = gettext
            store.pushErrorMessage({ success: true, detail: $gettext('Record successfully deleted') })
          }
        }
      }

      const accessToken = useCookie('accessToken').value
      const userInfo = useCookie('user').value
      const email = useCookie('email').value
      if (accessToken) {
        options.headers = {
          ...options.headers,
          'X-W-Auth': `/Token Email="${email || userInfo?.email || ""}", Token="${accessToken}"/`,
        }
      }

      if (options.inline) {
        options.ignoreResponseError = true
      }

      return { options }
    },

    async afterFetch(ctx) {
      const { data, response } = ctx

      let parsedData = null
      try {
        parsedData = destr(data)
      } catch (error) {
        console.error(error)
      }
      const { $gettext } = gettext
      const appStore = useAppStore()

      if (
        response.status === 401 ||
        (response.status === 403 && response._data.error === 'Auth token does not match with any user')
      ) {
        const authStore = useAuthStore()
        appStore.pushErrorMessage(response._data)
        await authStore.logout()
      }

      if (response.status === 403) {
        appStore.pushErrorMessage({
          status: response.status,
          detail: $gettext('You do not have sufficient permissions to perform this operation'),
        })
        return Promise.resolve(true)
      }

      if (response.status === 404) {
        appStore.pushErrorMessage({
          status: response.status,
          detail: $gettext('Resource not found'),
        })
        return Promise.resolve(true)
      }

      if (
        [
          400, 403, 422, 409, 500,
        ].includes(response.status)
      ) {
        if (
          response.status === 500 &&
          /Warning: rename.+doctrine\/orm\/Proxies.+Access is denied/.test(response._data)
        ) {
          console.log('CACHE CLEAR ERROR PANIC')
        } else {
          appStore.pushErrorMessage(response._data)
          return Promise.resolve({ error: response._data })
        }
      }

      return { data: parsedData, response }
    },
  },
})
